import {
  KeyboardAvoidingView,
  SafeAreaView,
  View,
  VStack,
  Text
} from "@gluestack-ui/themed";
import { CustomHeader } from "@repo/core/components/layout/CustomHeader";
import { StatusBar } from "@repo/core/components/layout/StatusBar";
import { ChangePasswordController } from "./controller";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Button } from "@repo/core/components/core/Button";
import PasswordStrength from "./components/PasswordStrength";

function ChangePassword() {
  const {
    back,
    handleOnSubmitForm,
    control,
    isSubmitting,
    isValidPassword,
    hasMinLowercaseLetters,
    hasMinNumbers,
    hasMinCharacters,
    passwordStrength,
    onKeyPressDisablePaste,
    onKeyUpDisablePaste,
    isMobile
  } = ChangePasswordController();
  return (
    <VStack flex={1} bg="$backgroundLight100" overflow="hidden" height="$100vh">
      <StatusBar barStyle="light-content" showCustomStatusBar />
      <SafeAreaView flex={1} bg="$backgroundLight0">
        <VStack flex={1} p="$4" space="lg">
          <VStack px="$2">
            <CustomHeader title="Redefinir senha" onBackPress={back} />
          </VStack>
          <VStack flex={1}>
            <KeyboardAvoidingView flex={1}>
              <View
                flexGrow={1}
                gap="$6"
                pt="$4"
                w={!isMobile ? 480 : "$full"}
                m={!isMobile ? "auto" : undefined}
              >
                <Text>Crie sua nova senha</Text>
                <InputControlled
                  control={control}
                  name="newPassword"
                  placeholder="Digite sua senha"
                  size="md"
                  returnKeyType="next"
                  label="Nova senha"
                  isRequired
                  type="password"
                  secureTextEntry
                />

                <InputControlled
                  control={control}
                  name="confirmNewPassword"
                  placeholder="Repita sua senha"
                  size="md"
                  label="Repetir senha"
                  returnKeyType="next"
                  isRequired
                  type="password"
                  secureTextEntry
                  contextMenuHidden
                  onKeyPress={(e) => onKeyPressDisablePaste(e)}
                  onKeyUp={(e) => onKeyUpDisablePaste(e)}
                  onContextMenu={(e) => e.preventDefault()}
                />
                <PasswordStrength
                  hasMinCharacters={hasMinCharacters}
                  hasMinNumbers={hasMinNumbers}
                  hasMinLowercaseLetters={hasMinLowercaseLetters}
                  passwordStrengthValue={passwordStrength}
                />
              </View>
              <View
                gap="$4"
                flexDirection={!isMobile ? "row-reverse" : "column"}
                justifyContent={!isMobile ? "center" : "center"}
                w={!isMobile ? 480 : "$full"}
                m={!isMobile ? "auto" : undefined}
              >
                <Button
                  size="xl"
                  isDisabled={!isValidPassword}
                  isLoading={isSubmitting}
                  action={isValidPassword ? "primary" : "secondary"}
                  text="Salvar"
                  w={!isMobile ? "$1/2" : "$full"}
                  onPress={handleOnSubmitForm}
                />
                <Button
                  isDisabled={isSubmitting}
                  variant="outline"
                  action="negative"
                  size="xl"
                  w={!isMobile ? "$1/2" : "$full"}
                  text="Cancelar"
                  onPress={back}
                />
              </View>
            </KeyboardAvoidingView>
          </VStack>
        </VStack>
      </SafeAreaView>
    </VStack>
  );
}
export default ChangePassword;
